var exports = {
  "k": "xfd349460--ce7bb6--container",
};

module.exports = exports;
